import clsx from 'clsx';

export default function Container(props) {
  const { className, ...others } = props;
  return (
    <div
      className={clsx({
        'nsw-container': 1,
        [className]: className,
      })}
      {...others}
    />
  );
}
